import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../auth';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  if (!isLoggedIn()) {
    // redirect to /login, preserving where they were trying to go
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  return children;
};

export default RequireAuth;
